/* Bundle Prompt — per-product 2-item bundle toast.
   Eligible products are auto-discovered from the "2-voor-deals" Shopify
   collection via the bundle-deals-data JSON island (snippets/bundle-deals-data.liquid),
   loaded on the first add to cart by assets/cart-upsell-data.js. Each eligible
   product is its own bundle: adding 1 prompts for a 2nd color of the SAME
   product; adding 2 confirms. Other products don't cross-trigger.
   Cart contents come from the cart store and its events, so no /cart.js request is needed. */
import Cart from "cart-store";
import { loadBundleDeals } from "cart-upsell-data";

const BUNDLE_MAX = 2;
const TOAST_DURATION = 4000;

const I18N = (() => {
  const fallback = {
    added: "Added \u2713  Pick a 2nd color for the bundle",
    complete: "Bundle complete \u2713",
  };
  const el = document.getElementById("bundle-prompt-i18n");
  if (!el) return fallback;
  try {
    const parsed = JSON.parse(el.textContent || "{}");
    return { ...fallback, ...parsed };
  } catch {
    return fallback;
  }
})();

class BundlePrompt {
  constructor() {
    this.previousCart = Cart.getState().cart;
    this._buildToast();
    this._bind();
  }

  _buildToast() {
    this.toast = document.createElement("div");
    this.toast.className = "bundle-prompt__toast";
    this.toast.setAttribute("role", "status");
    this.toast.setAttribute("aria-live", "polite");
    this.toast.hidden = true;
    document.body.appendChild(this.toast);
  }

  _bind() {
    document.addEventListener("on:cart:loaded", (e) => {
      const detail = e.detail || {};
      const previous = this.previousCart;
      const next = detail.cart || Cart.getState().cart;
      this.previousCart = next;
      if (detail.type === "ADD") this._promptForAdd(previous, next);
    });
  }

  _perProductCounts(cart, handles) {
    const map = new Map();
    if (!cart || !Array.isArray(cart.items)) return map;
    for (const item of cart.items) {
      if (handles.has(item.handle)) {
        map.set(
          item.handle,
          (map.get(item.handle) || 0) + (item.quantity || 0),
        );
      }
    }
    return map;
  }

  async _promptForAdd(previousCart, cart) {
    try {
      const handles = new Set(Object.keys(await loadBundleDeals()));
      if (!handles.size) return;
      const before = this._perProductCounts(previousCart, handles);
      const after = this._perProductCounts(cart, handles);
      for (const [handle, qty] of after) {
        if (qty > (before.get(handle) || 0)) {
          this._showToast(this._toastMessage(Math.min(qty, BUNDLE_MAX)));
          break;
        }
      }
    } catch (error) {
      console.error("bundle-prompt: could not check the bundle deal", error);
    }
  }

  _toastMessage(count) {
    return count >= BUNDLE_MAX ? I18N.complete : I18N.added;
  }

  _showToast(text) {
    this.toast.textContent = text;
    this.toast.hidden = false;
    requestAnimationFrame(() => this.toast.classList.add("is-visible"));
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => {
      this.toast.classList.remove("is-visible");
      setTimeout(() => {
        this.toast.hidden = true;
      }, 250);
    }, TOAST_DURATION);
  }
}

const init = () => {
  new BundlePrompt();
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
